import ModelUtil from '@leverege/model-util';
import AttributeSortFieldModel from "./AttributeSortFieldModel.js";
const TYPE = 'molten.SortModel';
function create(extend) {
  return {
    type: TYPE,
    fields: [AttributeSortFieldModel.create()],
    ...extend
  };
}
const common = {
  ...ModelUtil.createAllArray('fields')
};
export default {
  TYPE,
  create,
  ...common,
  setField(model, index, field) {
    const idx = model.fields?.findIndex(f => f.attrName === field.attrName);
    if (idx != null && idx > -1) {
      return common.setField(model, idx, field);
    }
    return common.setField(model, index, field);
  },
  addField(model, field) {
    const idx = model.fields?.findIndex(f => f.attrName === field.attrName);
    if (idx != null && idx > -1) {
      return common.setField(model, idx, field);
    }
    return common.addField(model, field);
  }
};